import { TR, TDT, TA } from "../../components";
import { FiEdit2 } from "react-icons/fi";
import { RiDeleteBin5Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import TableContext from "../Provider/TableContext";
import useApp from "../../../../Hooks/useApp";
import { hasOtherPermission } from "../../../../Util/Permissions";

function TableRow({ doc }) {
  const { user, setShowNotAuthorized } = useApp();
  const navigate = useNavigate();
  const { setShowDeleteModal, setShipmentId } = useContext(TableContext); // ✅ fixed

  const showDelete = () => {
    setShipmentId(doc?.id); // ✅ use setShipmentId
    setShowDeleteModal(true);
  };

  const handleAuth = () => setShowNotAuthorized(true);

  return (
    <TR>
      <TDT name="Customer" txt={doc?.customer?.name || "--"} />
      <TDT name="Vehicle" txt={doc?.vehicle?.name || "--"} />
      <TDT name="Driver" txt={doc?.driver?.name || "--"} />
      <TDT name="Dispatcher" txt={doc?.dispatcher?.name || "--"} />
      <TDT
        name="Order Date"
        txt={
          doc?.order_date ? new Date(doc.order_date).toLocaleDateString() : "--"
        }
      />
      <TDT name="Origin" txt={doc?.origin || "--"} />
      <TDT name="Destination" txt={doc?.destination || "--"} />
      <TDT name="Total Price" txt={doc?.total_price?.toFixed(2) || "0.00"} />
      <TDT
        name="Status"
        txt={
          <div
            className={`rounded-2xl w-fit px-4 ${
              doc?.status === "pending"
                ? "bg-red"
                : doc?.status === "in_transit"
                ? "bg-yellow-500"
                : doc?.status === "delivered"
                ? "bg-green"
                : "bg-gray-400"
            }`}
          >
            <p className="text-white">{doc?.status || "--"}</p>
          </div>
        }
      />
      <TA name="Actions" id={doc?.id}>
        <div className="flex gap-4">
          <div
            className="cursor-pointer"
            onClick={() => navigate(`edit/${doc?.id}`)}
          >
            <p className="text-center flex gap-2">
              <FiEdit2 className="text-blue-500 text-2xl" />
              <span>Edit</span>
            </p>
          </div>

          <div
            className="cursor-pointer"
            onClick={
              hasOtherPermission(user, "delete_shipment")
                ? showDelete
                : handleAuth
            }
          >
            <p className="text-center flex gap-2">
              <RiDeleteBin5Line className="text-red text-2xl" />
              <span>Delete</span>
            </p>
          </div>
        </div>
      </TA>
    </TR>
  );
}

export default TableRow;
